/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { RichTextComponent } from '@msdyn365-commerce/core';
import { IEmbedYoutubeViewProps } from './embed-youtube';

export default (props: IEmbedYoutubeViewProps) => {
    const { videos } = props;
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                className='row_designing_your_layout_videos'
                data-enable-parallax={0}
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <div
                    className='pagebuilder-column-group'
                    data-content-type='column-group'
                    data-grid-size={12}
                    data-element='main'
                    style={{ display: 'flex' }}
                >
                    {videos &&
                        videos.map((video, index) => {
                            return (
                                <div
                                    key={index}
                                    className='pagebuilder-column'
                                    data-content-type='column'
                                    data-appearance='full-height'
                                    data-background-images='{}'
                                    data-element='main'
                                    style={{
                                        justifyContent: 'flex-start',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        backgroundPosition: 'left top',
                                        backgroundSize: 'cover',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundAttachment: 'scroll',
                                        borderStyle: 'none',
                                        borderWidth: '1px',
                                        borderRadius: '0px',
                                        width: '50%',
                                        margin: '0px',
                                        padding: '10px',
                                        alignSelf: 'stretch'
                                    }}
                                >
                                    <div
                                        data-content-type='text'
                                        data-appearance='default'
                                        data-element='main'
                                        style={{
                                            borderStyle: 'none',
                                            borderWidth: '1px',
                                            borderRadius: '0px',
                                            margin: '0px',
                                            padding: '0px'
                                        }}
                                    >
                                        <p id='WMDYP3I' style={{ textAlign: 'center' }}>
                                            <strong>{video.videoCaption}</strong>
                                        </p>
                                        <RichTextComponent text={video.description} />
                                    </div>
                                    <div data-content-type='video' data-appearance='default' data-element='main' style={{ margin: '0px' }}>
                                        <div className='pagebuilder-video-inner' data-element='inner'>
                                            <div
                                                className='pagebuilder-video-wrapper'
                                                data-element='wrapper'
                                                style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', padding: '0px' }}
                                            >
                                                <div className='pagebuilder-video-container'>
                                                    <iframe
                                                        frameBorder={0}
                                                        allowFullScreen={video.allowFullscreen}
                                                        src={video.videoUrl?.destinationUrl}
                                                        data-element='video'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
};
